import React, { Fragment } from 'react';
import { SubmitLoader } from '~/components/common/loaders/submit';
import { Translate } from '~/i18n';

type BannerCardType = {
   title: React.ReactNode;
   amount: number | string;
   isLoading?: boolean;
   handelRequestButton?: () => void;
};
const BannerCard = ({ title, amount, isLoading }: BannerCardType) => {
   // const { data: userPayout } = usePayoutInfo();

   return (
      <div className="h-24 px-5 py-4 bg-white !min-w-max xl:w-56 xl:h-32 sm:h-28 sm:w-44 w-36 rounded-lg bg-opacity-10">
         <div className="flex flex-col h-full">
            {isLoading ? (
               <SubmitLoader />
            ) : (
               <Fragment>
                  <div>
                     <div className="text-xs xl:text-sm">{title}</div>
                     <div className="xl:text-2xl flex text-xs md:text-xl !leading-6 gap-1">
                        <span className="font-semibold">{amount || 0}</span>
                        <span className="mx-0.5">
                           <Translate id="common:sar" />
                        </span>
                     </div>
                  </div>

                  {/* {handelRequestButton && (
                     <div className="mt-2 sm:mt-auto">
                        <button
                           type="button"
                           disabled={!userPayout?.show_create_claim_button}
                           onClick={handelRequestButton}
                           className="xl:text-sm text-xs whitespace-nowrap disabled:cursor-not-allowed rounded-[117px] border px-3 sm:px-6 py-0.5 sm:py-1">
                           <Translate id="payout:request payout" />
                        </button>
                     </div>
                  )} */}
               </Fragment>
            )}
         </div>
      </div>
   );
};

export default BannerCard;
